export class ReadingTimePresenter {
  static getReadingTime(data: string[]): string {
    // avoid empty / undefined data
    if (!data?.length) {
      return null;
    }
    return data[0].trim().replace('minutes', 'min');
  }
}
